$(window).on('load', function () {
  try {
    var map = document.getElementById('map');

    if (map) {
      var store_latlng = new google.maps.LatLng(45.5767359, -122.6386722);
      var mapOptions = {
        zoom: 8,
        center: store_latlng,
        mapTypeControl: false,
      };
      store_map = new google.maps.Map(document.getElementById('map'), mapOptions);
      google.maps.event.trigger(store_map, 'resize');

      for (var i = 0; i < store_markers.length; i++) {
        var position = new google.maps.LatLng(store_markers[i].lat, store_markers[i].lng);
        var bounds = new google.maps.LatLngBounds();

        bounds.extend(position);
        var marker = new google.maps.Marker({
          position: position,
          map: store_map,
          title: store_markers[i].name,
          icon: pin_icon,
        });
      }
    }

    var address_marker = false;

    function codeAddress(address, dist, res) {
      var store_geocoder = new google.maps.Geocoder();
      store_geocoder.geocode({ address: address }, function (results, status) {
        if (status == 'OK') {
          store_map.setCenter(results[0].geometry.location);
        } else {
          return false;
        }

        var near_markers = [];
        store_markers.forEach(function (marker, ind) {
          if (res <= ind) {
            return false;
          }
          var marker_position = new google.maps.LatLng(marker.lat, marker.lng);
          var distInt = dist.match(/\d+/)[0];
          var distIntMeters = distInt / 0.00062137;
          var distance = google.maps.geometry.spherical.computeDistanceBetween(
            results[0].geometry.location,
            marker_position
          );
          if (distIntMeters > distance) {
            marker.distance = (distance * 0.00062137).toFixed(2);
            near_markers.push(marker);
          }
        });
        generateResultHTML(near_markers);
      });
    }

    function generateResultHTML(results) {
      jQuery('.locator__results').empty();
      results.forEach(function (marker) {
        var $template = jQuery(jQuery('#result-template').html()).clone();
        var url = 'https://www.google.com/maps/dir/?api=1';
        var destination = '&destination=' + marker.lat + ',' + marker.lng;
        var newUrl = url + destination;
        $template.attr({
          'data-lat': marker.lat,
          'data-lng': marker.lng,
        });
        $template.find('.title').text(marker.name);
        $template.find('.address').html(marker.address);
        $template.find('.directions').attr('href', newUrl);
        $template.find('.miles').text(marker.distance + ' Mi');
        jQuery('.locator__results').append($template);
      });
    }

    $('.stores__results').on('click', '.view-map .map', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $result_box = $this.closest('.result-box');
      var lat = parseFloat($result_box.data('lat'));
      var lng = parseFloat($result_box.data('lng'));

      if ($(window).width() < 768) {
        $('.stores').addClass('active');
      }
    });

    $('.locator__form form').on('submit', function (e) {
      e.preventDefault();
      var address = $(this).find('.zip').val();
      var dist = $(this).find('.distance').val();
      var res = $(this).find('.results').val();
      codeAddress(address, dist, res);
    });

    $('.stores .stores__map .back').on('click', function () {
      $('.stores').removeClass('active');
    });

    $('#shopify-section-visit .map').each(function () {
      let $this = $(this);
      let lat = parseFloat($this.data('lat'));
      let lng = parseFloat($this.data('lng'));
      let uluru = { lat: lat, lng: lng };
      // console.log(uluru);
      if (typeof google === 'undefined') {
        return;
      }
      let map = new google.maps.Map($this[0], {
        zoom: 16,
        center: uluru,
      });
      let marker = new google.maps.Marker({
        position: uluru,
        map: map,
      });
    });

    $('.template-page-visit .map-row .map-row__col--right .btn').on('click', function (e) {
      e.preventDefault();
      $('html, body')
        .stop()
        .animate(
          {
            scrollTop:
              $(window).width() < 767
                ? $('.event-title').offset().top - $('.header').height()
                : $('.event-title').offset().top,
          },
          300
        );
    });
  } catch (e) {
    Rollbar.error('map js', e);
  }
});
